import * as v from 'valibot';

export const ActivityIndicatorSchema = v.object({
  cids: v.array(v.string()),
  dates: v.array(
    v.object({
      zoneId: v.string(),
      date: v.number(),
    }),
  ),
  type: v.string(),
});
